import * as firebase from 'firebase/app'

const config = {
  apiKey: "AIzaSyAzDoO-DaptwBYhO6SOx5Q1ACk5XSTOQjc",
  authDomain: "otodidak-esd.firebaseapp.com",
  databaseURL: "https://otodidak-esd.firebaseio.com",
  projectId: "otodidak-esd",
  storageBucket: "otodidak-esd.appspot.com",
  messagingSenderId: "920783757279",
  appId: "1:920783757279:web:5bf1b87d18a0fb50c42e6a"
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const messaging = firebase.messaging()

messaging.usePublicVapidKey("BPsyciTpVEwhwq_pL8PXkDyamY3Te4-1eGkwxdDqZJIVwk_DnOWi6tcHtho9US1-WAIb5EJMmB4B6oJcYffLtlc")

export default firebase